import * as React from 'react';

import { CheckboxGroup, CheckboxProps } from '@lendi-ui/checkbox';
import { validateNotEmpty } from '@funnels/utils';

import HiddenField from '../../../Fields/HiddenField';

interface NeedsAndAnalysisCheckboxGroupProps {
  // need to use first child's FIELD_PATHS type in array to do validation or form validation wont work properly
  checkboxGroupValidateName: string;
  values: string[];
  children: React.ReactElement<CheckboxProps> | React.ReactElement<CheckboxProps>[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isOptional?: boolean;
}

export const NeedsAndAnalysisCheckboxGroup = (props: NeedsAndAnalysisCheckboxGroupProps) => {
  const {
    // need to use first child's FIELD_PATHS type in array to do validation or form validation wont work properly
    checkboxGroupValidateName,
    values,
    children,
    isOptional = false,
    onChange,
  } = props;

  return (
    <>
      <CheckboxGroup values={values} onChange={onChange}>
        {children}
      </CheckboxGroup>
      <HiddenField name={checkboxGroupValidateName} validate={validateNotEmpty('Please select a value.', isOptional)} />
    </>
  );
};
